import React, { useState } from "react";
import { Card, Form, Input, Select, Switch, Tabs, Button } from "antd";
import HtmlEditor from "components/editors/HTMLEditor";
import { Card as BootCard } from "react-bootstrap";
import WidgetSectionTitle from "widgets/WidgetSectionTitle";
import { useNavigate } from "react-router-dom";

const CATEGORY_OPTIONS = [
  { value: "announcement", label: "Announcement" },
  { value: "promo", label: "Promo" },
  { value: "update", label: "Update" },
  { value: "seasonal", label: "Seasonal" },
];

const NEWSLETTER_VARIABLES = ["businessName", "subscriberEmail", "unsubscribeUrl"];

const switchStyles = (info) => ({
  root: {
    backgroundColor: info.props.checked ? "#00D27A" : "#f0f0f0",
    borderColor: info.props.checked ? "#28a745" : "#d9d9d9",
    borderRadius: "16px",
  },
  handle: {
    backgroundColor: "#fff",
  },
});

export default function NewsletterTemplateForm({
  initialValues,
  onSubmit,
  submitLabel = "Save Template",
  isEditing = false,
}) {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [form] = Form.useForm();

  const handleFinish = async (values) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
    } catch (err) {
      throw err;
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3 mt-3 gap-3">
        <WidgetSectionTitle
          icon="envelope-open-text"
          title={isEditing ? "Edit Newsletter Template" : "Create Newsletter Template"}
          subtitle="Define a new email or SMS template"
          className="mb-3 mt-3 flex-1"
        />

        <Button
          variant="info"
          size="sm"
          className="text-sm"
          onClick={() => navigate(-1)}
        >
          Go Back
        </Button>
      </div>

      <Form
        layout="vertical"
        form={form}
        initialValues={initialValues}
        onFinish={handleFinish}
        style={{ fontFamily: "Inter" }}
      >
        <div className="row g-3 d-flex align-items-stretch">
          {/* LEFT */}
          <div className="col-lg-5">
            <Card title="Template Info" className="custom-shadow">
              <Form.Item
                label="Name"
                name="name"
                rules={[{ required: true, message: "Name is required" }]}
              >
                <Input placeholder="e.g. Monthly Digest" />
              </Form.Item>

              <Form.Item label="Category" name="category">
                <Select
                  placeholder="Select category"
                  options={CATEGORY_OPTIONS}
                  allowClear
                  popupStyle={{ fontFamily: "Inter" }}
                />
              </Form.Item>

              <Form.Item label="Thumbnail URL" name="thumbnailUrl">
                <Input placeholder="https://..." />
              </Form.Item>

              <Form.Item label="Premium" name="premium" valuePropName="checked">
                <Switch styles={switchStyles} />
              </Form.Item>
            </Card>
          </div>

          {/* RIGHT */}
          <div className="col-lg-7 d-flex">
            <BootCard
              title="Template Content"
              className="custom-shadow flex-fill d-flex flex-column"
              style={{ display: "flex", flexDirection: "column", height: "100%" }}
            >
              <Tabs
                tabBarStyle={{
                  padding: "0px 16px",
                  paddingTop: "8px",
                  borderBottom: "1px solid #E2E8F0",
                  marginBottom: "0px",
                  fontFamily: "Inter",
                }}
                styles={{ indicator: { backgroundColor: "#00D27A" } }}
                style={{ flex: 1, display: "flex", flexDirection: "column" }}
                items={[
                  {
                    key: "html",
                    label: "HTML Body",
                    children: (
                      <Form.Item
                        name="htmlBody"
                        rules={[{ required: true, message: "HTML body is required" }]}
                        style={{ flex: 1, display: "flex", flexDirection: "column", margin: 0 }}
                      >
                        <HtmlEditor
                          variables={NEWSLETTER_VARIABLES}
                          style={{ flex: 1, minHeight: 0 }}
                          height={450}
                        />
                      </Form.Item>
                    ),
                  },
                  {
                    key: "preview",
                    label: "Preview",
                    children: (
                      <Form.Item shouldUpdate style={{ flex: 1, margin: 0 }}>
                        {() => (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: form.getFieldValue("htmlBody"),
                            }}
                          />
                        )}
                      </Form.Item>
                    ),
                  },
                ]}
              />
            </BootCard>
          </div>
        </div>

        <div className="mt-3 text-end">
          {isSubmitting ? (
            <Button
              type="primary"
              loading
              iconPlacement="end"
              size="sm"
              className="ms-2 bg-success"
              style={{ fontFamily: "Inter" }}
            >
              Saving
            </Button>
          ) : (
            <Button type="primary" variant="success" htmlType="submit" className="bg-success">
              {submitLabel}
            </Button>
          )}
        </div>
      </Form>
    </>
  );
}